// extracted by mini-css-extract-plugin
export default {"mainScreenContainer":"styles_mainScreenContainer__eqJht","intro":"styles_intro__ETwSM","addProblemButton":"styles_addProblemButton__JhudL"};